import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const Logo = ({ url , className , image , title , tealiumAttributes  })=>/*#__PURE__*/ React.createElement("a", swcHelpers.extends({
        className: `logo ${className || ''}`,
        href: url,
        title: title,
        "data-t": "logo-link"
    }, tealiumAttributes), /*#__PURE__*/ React.createElement("img", {
        className: "logo__img",
        src: image.url,
        alt: image.altText || title,
        "data-t": "logo-image"
    }))
;

export { Logo as default };
//# sourceMappingURL=Logo.js.map
